module.exports = __webpack_public_path__ + "static/media/petal_grey_bg.f4f8c8ec.svg";